/**
 * 时间日期工具类
 */
 import moment from 'moment'
 moment.locale("zh-cn", {
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_")
  
 });
 const a={
  cycle(val) {
    let time = moment(val[0]).startOf("week");
    let weekArr = []
    for (let i = 1; i < 8; i++) {
        let tempTime = moment(time).weekday(i);
        let tr = moment(tempTime).format("YYYY-MM-DD (dddd)");
        tr = tr.replace("星期", "周");
        weekArr.push(tr);
    }
    return weekArr 
   }  
 }
 export default a
 